import * as React from "react";
import { Box, Button, Typography,Grid2, CircularProgress, useMediaQuery, IconButton } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import StepperCard from "../StepperCard";
import { CustomStepConnector, StepIcon, useSteps  } from "../StepperComponents"; // Import steps
import { useSelector, useDispatch } from 'react-redux';
import { checkAndNavigate, faceMatchApi, generateQR, liveness, SeflieandSignatureStatus, setActiveStep } from "../../../Redux/usersSlice";
import icon from "../../../Assets/Images/icon.svg"
import CaptureStyles from "./Capture.module.css"
import success from "../../../Assets/Images/bvsuccess.svg"
import CaptureStyles1 from "./capturePhotoStyle.module.css";
import img from "../../../Assets/Images/Capture.png"
import navLogo from "../../../Assets/Images/logo.svg"
import collab from '../../../Assets/Images/collab1.svg';
import SignatureStyles from "../Signature/Signature.module.css"
import Webcam from "react-webcam";
import { publicIpv4} from 'public-ip';
import io from "socket.io-client";
import { QRCodeCanvas } from "qrcode.react";
import LinearProgress from '@mui/material/LinearProgress';
import { ArrowBack } from "@mui/icons-material";
const webcamRef = React.createRef(null);

export default function CaptureSelfie() {
    const steps = useSteps();
  const navigate = useNavigate();
  const location = useLocation();
  const SOCKET_SERVER_URL = window.location.hostname.includes("localhost") || window.location.hostname.includes("staging") ? "https://registration-service-staging.tradeboss.co": "https://registration-service.tradeboss.co"

  const dispatch = useDispatch();

  const [openCamera, setOpenCamera] = React.useState(false)
  const [capturedImage, setCapturedImage] = React.useState(null);
  const [matchScore , setMatchScore] = React.useState(0)
  const [livelinessScore , setLivelinessScore] = React.useState(0)
  const [socket, setSocket] = React.useState(null);
  const [isQRMode, setIsQRMode] = React.useState(false);
  const [qrURL, setQrURL] = React.useState("");
  const [error,setError] = React.useState(false)
  const [errorMessage,setErrorMessage] = React.useState("")
  const [isCompleted,setIsCompleted] = React.useState(false)
  const [isLoading ,setIsLoading] = React.useState(false)
  const [passed,setPassed] = React.useState(false)
  const [checkStatus,setCheckStatus] = React.useState(false)

  const {activeStep,userData,panData,faceMatch,source} = useSelector( state => state.user);
  const {email , mobile} = userData
  console.log("userData", panData?.facematch,faceMatch)

  const backendResponse=userData.steps

    //  const theme = useTheme();
     const isMobile = useMediaQuery('(max-width:1000px)');

  const screen768px = useMediaQuery("(max-width : 768px)")
  const isSmallScreen = useMediaQuery("(max-width : 600px)")

  React.useEffect(()=>{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "selfie_page_viewed",
      page_path: window.location.pathname
    });
  },[])

  // Sync step with URL path
  React.useEffect(() => {
    const currentStep = steps.findIndex(
      (step) => step.path === location.pathname
    );
       if (currentStep !== -1)  dispatch(setActiveStep(currentStep));
  }, [location.pathname, setActiveStep]);

  React.useEffect(()=>{
      (async ()=>{
          try{
              const signatureStatus = await dispatch(SeflieandSignatureStatus({mobile,email,type : "selfie"})).unwrap();
              if(signatureStatus?.data?.data?.status){
                setIsCompleted(true)
                if(isQRMode){
                  setQrURL("")
                  setIsQRMode(false)
                  setErrorMessage("")
                }
              }else{
                if(isQRMode){
                  setErrorMessage("Your selfie is still pending !!")
                }
              }
          }catch(e){
              console.log(e)
          }
      })()
    },[checkStatus])

  React.useEffect(() => {
    if (!isQRMode) return;

    const socketInstance = io(SOCKET_SERVER_URL, { transports: ["websocket"] });
    setSocket(socketInstance);

    socketInstance.on("connect", () => {
        console.log("Connected to Socket.io server with ID:", socketInstance.id);
    });

    setTimeout(() => {
        const registrationPayload = {
            user_id: userData?.user_id,
            socket_id: socketInstance.id,
            stage: "Selfie"
        };
        socketInstance.emit('register', registrationPayload);
        localStorage.setItem("socket_id", socketInstance.id);
    }, 2500);

    socketInstance.on("signature-status", (message) => {
        window.location.assign(message);
    });

    return () => {
      socketInstance.disconnect();
      console.log('Disconnected from Socket.io server');
    };

}, [isQRMode]);

  

  const handleNextLogic=async()=>{
     const { payload } = await dispatch(checkAndNavigate());

    console.log(payload.allComplete)

    if (payload.allComplete) {
      // All required steps completed - go to products
      console.log("Navigating to dis page...")
      navigate("/dis");
    } else {

      // First check if there are incomplete steps forward (normal flow)
      let nextIncompleteStep = null;

      // Check forward steps first
      for (let i = activeStep + 1; i < steps.length; i++) {
        const step = steps[i];
        const isComplete = step.substeps
          ? step.substeps.every(sub => userData.steps[sub.name]?.status)
          : userData.steps[step.name]?.status;
        console.log("Forward steps completed --->", isComplete)

        if (!isComplete) {
          nextIncompleteStep = step;
          console.log("Forward steps Incomplete navigating to", JSON.stringify(step))
          break;
        }
      }

      // If no incomplete steps forward, check all steps
      if (!nextIncompleteStep) {
        console.log("No incomplete steps forward checking any in backward steps")
        for (let i = 0; i < steps.length; i++) {
          const step = steps[i];
          const isComplete = step.substeps
            ? step.substeps.every(sub => userData.steps[sub.name]?.status)
            : userData.steps[step.name]?.status;

          if (!isComplete) {
            nextIncompleteStep = step;
            console.log("Backward steps Incomplete navigating to", JSON.stringify(step))
            break;
          }
        }
      }

      const stepIndex = steps.findIndex(s => s.path === nextIncompleteStep.path);
      console.log("Navigating to the specific step according to the condition", stepIndex)
      if (stepIndex !== -1) {
        dispatch(setActiveStep(stepIndex));
        navigate(nextIncompleteStep.path);
      }

    }

  }

  // const handleSkip = () => {
  //   if (activeStep < steps.length - 1) {
  //     const nextStep = activeStep + 1;
  //     dispatch(setActiveStep(activeStep + 1));
  //     navigate(steps[nextStep].path);
  //   }
  // };

  const handleGenerateQR = async () => {
    setErrorMessage("")
    setPassed(false)
    setCapturedImage(null)
    if(isQRMode){
      setIsQRMode(false)
      return
    }

    try {
        const response = await dispatch(generateQR({ mobile, email, source: "Selfie" })).unwrap();
        setQrURL(response?.data?.url);
        setIsQRMode(true);
    } catch (error) {
        console.error('Failed to generate QR:', error);
    }
};

  console.log("qrURL",qrURL)

  const handleStepNavigate = (path) => {
    const stepIndex = steps.findIndex((step) => step.path === path);
    if (stepIndex !== -1) {
       dispatch(setActiveStep(stepIndex));
      navigate(path);
    }
  };


  //  const handleCapture = async () => {
  //   setPassed(false)
  //   setIsLoading(true)
  //   setError(false)
  //   setErrorMessage("")
  //   setLivelinessScore(0)
  //   setMatchScore(0) 

  //   if(capturedImage){
  //     setCapturedImage(false)
  //     setIsLoading(false)
  //     return
  //   }
    
  //   let imageSrc = webcamRef.current.getScreenshot({ width: 1280, height: 720, dpi: 96 });
  //   if(screen768px){
  //      imageSrc = webcamRef.current.getScreenshot({ width: 720, height: 1280, dpi: 96 });
  //   }
  //   if (imageSrc) {
  //     setCapturedImage(imageSrc); 

  //     try{
  //       console.log("hellooo")
  //       if(panData.facematch || faceMatch){
  //         console.log("hellooo1")
  //         const faceVerify = await dispatch(faceMatchApi({ mobile, email, selfieImage: imageSrc })).unwrap()
  //         console.log("hellooo2")
  //         console.log(faceVerify?.data?.data, "face")
  //         const data = faceVerify?.data?.data
  //         console.log(data, data?.success, "success")
  //         if (data?.success == true) {
            
  //           setMatchScore(data?.similarity)
  //           const ip = await publicIpv4()
  //           const livenessVerify = await dispatch(liveness({ mobile, email, selfieImage: imageSrc, ip: ip,facematch:panData?.facematch })).unwrap()
  //           const livenessResult = livenessVerify?.data?.data
  //           console.log(livenessResult, "livenessResult")
  //           if (livenessResult?.success) {
  //             console.log(livenessResult?.score, "livenessResult")
  //             setLivelinessScore(livenessResult?.score)
  //             setPassed(true)
  //           } else {
  //             setError(true)
  //             setErrorMessage(livenessResult?.message)
  //           }
  //           setIsLoading(false)
  //         } else {
  //           setError(true)
  //           setErrorMessage(data.message)
  //         }
  //       }else{
  //             const ip = await publicIpv4()
  //         const livenessVerify = await dispatch(liveness({ mobile, email, selfieImage: imageSrc, ip: ip, facematch: panData?.facematch })).unwrap()
  //             const livenessResult = livenessVerify?.data?.data
  //             console.log(livenessResult, "livenessResult")
  //             if(livenessResult?.success){
  //               console.log(livenessResult?.score, "livenessResult")
  //               setLivelinessScore(livenessResult?.score)
  //               setPassed(true)
  //               setIsLoading(false)
  //             }else{
  //               setError(true)
  //               setErrorMessage(livenessResult?.message)
  //           }

  //       }
        


  //       setIsLoading(false)
  //     }catch(error){
  //       setError(true)
  //       setIsLoading(false)
  //       setErrorMessage(error?.data?.data?.message)
  //     } 

  //   }
  //   console.log("Captured Base64 Image:", imageSrc); 
  // }


  


// const handleCapture = async () => {
//   setPassed(false);
//   setIsLoading(true);
//   setError(false);
//   setErrorMessage("");
//   // Remove setMatchScore(0) but keep liveness score reset
//   setLivelinessScore(0); 

//   if(capturedImage){
//     setCapturedImage(false);
//     setIsLoading(false);
//     return;
//   }
  
//   let imageSrc = webcamRef.current.getScreenshot({ width: 1280, height: 720, dpi: 96 });
//   if(screen768px){
//      imageSrc = webcamRef.current.getScreenshot({ width: 720, height: 1280, dpi: 96 });
//   }
  
//   if (imageSrc) {
//     setCapturedImage(imageSrc); 

//     try{
//       // REMOVE THE FACE MATCH CALL ENTIRELY
//       // const faceVerify = await dispatch(faceMatch({mobile,email,selfieImage : imageSrc})).unwrap()
      
//       // Proceed directly to liveness check
//       const ip = await publicIpv4();
//       const livenessVerify = await dispatch(liveness({mobile,email,selfieImage : imageSrc, ip : ip})).unwrap();
//       const livenessResult = livenessVerify?.data?.data;
      
//       console.log(livenessResult, "livenessResult");
      
//       if(livenessResult?.success){
//         console.log(livenessResult?.score, "livenessResult");
//         setLivelinessScore(livenessResult?.score);
//         setPassed(true);
//       }else{
//         setError(true);
//         setErrorMessage(livenessResult?.message);
//       }
//       setIsLoading(false);
//     }catch(error){
//       setError(true);
//       setIsLoading(false);
//       setErrorMessage(error?.data?.data?.message);
//     } 
//   }
// };


 const handleCapture = async () => {
    setIsLoading(true)
    setError(false)
    setErrorMessage("")
    setLivelinessScore(0)
    setMatchScore(0) 

    if(capturedImage){
      setCapturedImage(false)
      setIsLoading(false)
      return
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "selfie_captured",
      page_path: window.location.pathname
    });
    let imageSrc = webcamRef.current.getScreenshot({ width: 1280, height: 720, dpi: 96 });
    let device="Desktop"
    if(screen768px){
       imageSrc = webcamRef.current.getScreenshot({ width: 720, height: 1000, dpi: 96 });
       device="Mobile"
    }
    if (imageSrc) {
      setCapturedImage(imageSrc); 

      try{
        const faceVerify = await dispatch(faceMatchApi({mobile,email,selfieImage : imageSrc,device})).unwrap()
        console.log(faceVerify?.data?.data , "face")

    
        const data = faceVerify?.data?.data
        console.log(data , data?.success , "success")
        if(data?.success == true){
          setMatchScore(data?.similarity)
          const ip = await publicIpv4()
          const livenessVerify = await dispatch(liveness({ mobile, email, selfieImage: imageSrc, ip: ip, device})).unwrap()
          const livenessResult = livenessVerify?.data?.data
          console.log(livenessResult, "livenessResult")
          if(livenessResult?.success){
            console.log(livenessResult?.score, "livenessResult")
            setLivelinessScore(livenessResult?.score)
            setPassed(true)
          }else{
            setError(true)
            setErrorMessage(livenessResult?.message)
          }
          setIsLoading(false)
        }else{
          setError(true)
          setErrorMessage(data.message)
        }
        setIsLoading(false)
      }catch(error){
        setError(true)
        setIsLoading(false)
        setErrorMessage(error?.data?.data?.message)
      } 

    }
    console.log("Captured Base64 Image:", imageSrc); 
  }

    const handleSkipCS=()=>{

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "kyc_step_viewed",
        step_name: "selfie_skipped",
        page_path: window.location.pathname
      });
     // First check if there are incomplete steps forward (normal flow)
               let nextIncompleteStep = null;
                   
               // Check forward steps first
               for (let i = activeStep + 1; i < steps.length; i++) {
                 const step = steps[i];
                 const isComplete = step.substeps
                   ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                   : userData.steps[step.name]?.status;
                 console.log("Forward steps completed --->", isComplete)
           
                 if (!isComplete) {
                   nextIncompleteStep = step;
                   console.log("Forward steps Incomplete navigating to", JSON.stringify(step))
                   break;
                 }
               }
           
               // If no incomplete steps forward, check all steps
               if (!nextIncompleteStep) {
                 console.log("No incomplete steps forward checking any in backward steps")
                 for (let i = 0; i < steps.length; i++) {
                   const step = steps[i];
                   const isComplete = step.substeps
                     ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                     : userData.steps[step.name]?.status;
           
                   if (!isComplete) {
                     nextIncompleteStep = step;
                     console.log("Backward steps Incomplete navigating to", JSON.stringify(step))
                     break;
                   }
                 }
               }
           
               const stepIndex = steps.findIndex(s => s.path === nextIncompleteStep.path);
               console.log("Navigating to the specific step according to the condition", stepIndex)
               if (stepIndex !== -1) {
                 dispatch(setActiveStep(stepIndex));
                if(stepIndex === activeStep){
                      window.alert("You’ve reached the last step of onboarding, and it must be completed to continue ...!")
                 }else{
                 navigate(nextIncompleteStep.path);
                 }
               }
  }

  return (
    <main>
    <Box sx={{
        display: "flex",
        minHeight: "100vh !important",
        flexDirection:isMobile ? "column" : "row",
        backgroundImage: `url(${SignUpBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}>

      <Typography
        sx={{
          textAlign: "center",
          fontSize: "16px",
          fontFamily: "Inter400",
          display: {
            xs: "block", // shown on small screens
          },
          mt: "5px",
          "@media (min-width:1000px)": {
            display: "none"
          }
        }}
      >
        {`You are on step ${activeStep + 1} out of 8`}
      </Typography>

      <StepperCard
        activeStep={activeStep}
        handleStepNavigate={handleStepNavigate}
        backendResponse={backendResponse}
        CustomStepConnector={CustomStepConnector}
        StepIcon={StepIcon}
        steps={steps}
      />



      {isCompleted &&
        <Box className={SignatureStyles.content_wrapper}>
          <Grid2 flexDirection="column" display="flex" justifyContent="center" alignItems="center" height="600px" width="100%">
            <img src={success} alt="successLogo" />
            <Typography className={SignatureStyles.title}>Your selfie has been captured successfully</Typography>
            <Grid2 className={SignatureStyles.card}>
              <Button onClick={() => {
                setIsCompleted(false)
                setCapturedImage(null)
                setPassed(false)
              }} className={CaptureStyles.skip}>
                Edit
              </Button>
              <Button className={CaptureStyles.submit} onClick={handleNextLogic}>
                continue
              </Button>
            </Grid2>
          </Grid2> 
          
        </Box>
      }

      {/* Your content area */}
      {!isCompleted && <>
        {openCamera ? <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            // justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              color: "#481B9D",
              fontSize: "48px",
              fontFamily: "Inter900",
              paddingTop: "70px",
              marginBottom: "10px",
              textAlign: "center",
              padding: "20px",

            }}
            className={CaptureStyles1.heading}
          >
            Stay still and Capture now
          </Typography>
          <Grid2>
            {!isQRMode ? <div
              className={CaptureStyles1.img_container}
            // style={{
            //   width: "267px",
            //   height: "273px",
            //   border: "8px solid #1CF400",
            //   borderRadius: "50%",
            //   overflow: "hidden",
            //   position: "relative",
            //   display: "flex",
            //   justifyContent: "center",
            //   "@media  screen and (max-width:600px)": {
            //     width: "200px",
            //     height: "200px",
            //   }
            // }}
            >
              {capturedImage ? (
                <img
                  src={capturedImage}
                  alt="Captured"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <Webcam
                  className={CaptureStyles1.web_cam}
                  // style={{ objectFit: "cover",
                  //     width: "300px",
                  //     height: "300px",
                  //     "@media  screen and (max-width:600px)": {
                  //       width: "200px",
                  //       height: "200px",
                  //     }
                  //  }}
                  screenshotFormat="image/jpeg"
                  screenshotQuality={1}
                  imageSmoothing={true}
                  mirrored={true}


                  ref={webcamRef}
                />
              )}
            </div> :
              <Grid2>
                <Typography className={SignatureStyles.sub_title}>Scan This QR on your Phone</Typography>
                <Grid2 className={SignatureStyles.qrCodeGrid}>
                  <QRCodeCanvas value={qrURL} size={159} />
                </Grid2>
              </Grid2>}
          </Grid2>
          {capturedImage && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", width: "300px", marginTop: "20px" }}>
            {isLoading ? <Box sx={{ width: '100%' }}>
              <LinearProgress />
            </Box> :
              <>
                <Typography>
                  Face Match - {matchScore > 0 ? `${matchScore.toFixed(2)}%` : "NA"} {/* if NA , Face match is skiped */}
                  </Typography>
                <Typography sx={{ marginLeft:"5px"}} >liveness - {livelinessScore?.toFixed(2)}%</Typography></>}
          </Grid2>}
          {/* // With this simplified version: */}
          {/* {capturedImage && <Grid2 sx={{ display: 'flex', justifyContent: "center", alignItems: "center", width: "300px", marginTop: "20px" }}>
            {isLoading ? <Box sx={{ width: '100%' }}>
              <LinearProgress />
            </Box> :
              <Typography>Liveness - {livelinessScore?.toFixed(2)}%</Typography>}
          </Grid2>} */}
          {error && !isQRMode && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
            <Typography sx={{ color: "red", textAlign: "center" }}>{errorMessage}</Typography>
          </Grid2>}
          {passed && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
            <Typography sx={{ color: "green" }}>Face Match Success</Typography>
          </Grid2>}
          {/* // With this: */}
          {/* {passed && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
            <Typography sx={{ color: "green" }}>Liveness Check Passed</Typography>
          </Grid2>} */}


          {/* <Grid2>
            <Button
              className={CaptureStyles1.skip_button}
              variant="outlined"
              onClick={() => console.log("Skip Now clicked")}
            >
              Skip Now
            </Button>
          </Grid2> */}

          {
            isSmallScreen ? <>
              <Typography className={CaptureStyles1.footerText}>
                Please allow LOCATION and CAMERA permissions when requested. You
                need to do this only ONCE as per SEBI regulations, to open a Demat
                account.
              </Typography>
              <Grid2 className={CaptureStyles1.but_card}>
                <Grid2>
                   
                  {!passed && <Button
                    className={CaptureStyles1.con_button}
                    onClick={handleCapture}
                    disabled={isLoading}
                  >
                    {capturedImage ? "Retake" : "Capture Photo"}
                  </Button>}
                  {passed && <Button className={CaptureStyles1.con_button}
                    onClick={() => setIsCompleted(true)}>
                    Continue
                  </Button>}
                  {passed && <Typography className={SignatureStyles.txt} mt="20px" >
                  <span style={{ textDecoration: "underline", color: "blue", cursor: "pointer" , fontSize : "16px" }} onClick={() =>{
                    setIsCompleted(false)
                    setCapturedImage(null)
                    setPassed(false)
                  } }>Take Selfie again</span>
                </Typography>}

                 
                  <Grid2 mt={2}>
                        <Button Button
                        className={CaptureStyles.skip_button}
                        variant="outlined"
                        onClick={handleSkipCS}
                      >
                        Skip Now
                      </Button>
                  </Grid2>
                </Grid2>


              </Grid2>
            </> : <>
              <Grid2 className={CaptureStyles1.but_card}>
                
                {!isQRMode && <Grid2>
                  {!passed && <Button
                    className={CaptureStyles1.con_button}
                    onClick={handleCapture}
                    disabled={isLoading}
                  >
                    {capturedImage ? "Retake" : "Capture Photo"}
                  </Button>}
                  {passed && <Button className={CaptureStyles1.con_button}
                    onClick={() => setIsCompleted(true)}>
                    Continue
                  </Button>}
                  
                  {passed && <Typography className={SignatureStyles.txt} mt="20px" >
                  <span style={{ textDecoration: "underline", color: "blue", cursor: "pointer" , fontSize : "16px" }} onClick={() =>{
                    setIsCompleted(false)
                    setCapturedImage(null)
                    setPassed(false)
                  } }>Take Selfie again</span>
                </Typography>}

                </Grid2>}
                {!passed && <Button disabled={isLoading} onClick={handleGenerateQR} className={CaptureStyles1.con_button} sx={{
                  fontSize: "16px !important",
                  "@media screen and (max-width : 768px)": {
                    display: "none"
                  }
                }}>
                  {isQRMode ? "Cancel" : "Capture on mobile"}
                </Button>}
                   <br></br>
                

              </Grid2>
               <Grid2 m={2}>
                    <Button
                        className={CaptureStyles.skip}
                        variant="outlined"
                        onClick={handleSkipCS}
                      >
                        Skip Now
                      </Button>
                    </Grid2>
              {isQRMode && <Grid2>
                <Typography className={SignatureStyles.txt} mt="20px" >
                  After you complete selfie on mobile please <span style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }} onClick={() => setCheckStatus(!checkStatus)}>click here</span> to continue
                </Typography>
                {errorMessage && <Typography className={SignatureStyles.upload_txt} sx={{ fontSize: "14px", color: "red !important", textAlign: "center", mt: "10px" }}>
                  {errorMessage}
                </Typography>}
              </Grid2>}
              {!isQRMode && <Typography className={CaptureStyles1.footerText}>
                Please allow LOCATION and CAMERA permissions when requested. You
                need to do this only ONCE as per SEBI regulations, to open a Demat
                account.
              </Typography>}
            </>
          }


          <Box className={CaptureStyles1.card} mt="20px">
            <img
              src={icon} // Replace with your image URL
              alt="Checkmark"
              className={CaptureStyles1.icon}
            />
            <Typography className={CaptureStyles1.txt}>
              Your account details are safe & secure with us.
            </Typography>
          </Box>

        </Box> : <Box className={CaptureStyles.outer}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection:"column",
              position: 'relative',
              width: '100%',
              marginBottom: '10px',
              marginTop: '10px',
            }}>
              {/* Back arrow button - only shows below 1000px */}
              <Box sx={{
                position: 'absolute',
                left: 0,

                '@media (min-width: 1000px)': {
                  display: 'none' // Explicitly hide above 1000px
                },
                '@media (max-width: 510px)': {
                  marginBottom: "20px"
                }
              }}>
                <IconButton
                  onClick={() => navigate('/step-6')} // Or your custom back handler
                  aria-label="Go back"
                  sx={{
                    color: '#000', // Customize color
                    padding: '16px',
                    '@media (max-width: 400px)': {
                      paddingLeft: "5px"
                    }
                  }}
                >
                  <ArrowBack /> {/* Make sure to import from @mui/icons-material */}
                </IconButton>
              </Box>

              {/* Logo - centered */}
              <img
                src={source == "cosmos" ? collab : navLogo}
                alt="Logo"
                style={{
                  // Adjust margin to account for arrow on mobile
                  marginLeft: { xs: '40px', md: 0 }
                }}
                className={source == "cosmos" ? CaptureStyles.twologo :
                  CaptureStyles.nav_logo}
              />
              {
                source == "cosmos" &&
                <Typography className={CaptureStyles.txt1}>
                  Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
                </Typography>
              }
            </Box>

          <Typography className={CaptureStyles.title}>Capture Photo</Typography>
          <Typography className={CaptureStyles.subtitle}>
            Click a selfie for your KYC verification.
          </Typography>

          <Grid2 className={CaptureStyles.card}>
            {/* Left Column - Image */}
            <Grid2>
              <Box className={CaptureStyles.imageContainer}>
                <img
                  src={img}
                  alt="Selfie Example"
                  className={CaptureStyles.image}
                />
              </Box>
            </Grid2>

            {/* Right Column - Content */}
            <Grid2>
              <Box className={CaptureStyles.instructions}>
                <Typography className={CaptureStyles.instruction}>
                  <span className={CaptureStyles.number}>1. </span>
                  Ensure Good Lighting – Take the selfie in a well-lit area for
                  clear visibility.
                </Typography>
                <Typography className={CaptureStyles.instruction}>
                  <span className={CaptureStyles.number}>2. </span>
                  Face the Camera Directly – Look straight at the camera with
                  a neutral expression or slight smile.
                </Typography>
                <Typography className={CaptureStyles.instruction}>
                  <span className={CaptureStyles.number}>3. </span>
                  No Accessories – Remove hats, sunglasses, or anything that
                  obstructs your face.
                </Typography>
                <Typography className={CaptureStyles.instruction}>
                  <span className={CaptureStyles.number}>4. </span>
                  Avoid Blurry Images – Ensure the photo is sharp, with no
                  filters or edits.
                </Typography>
              </Box>
            </Grid2>
          </Grid2>

          {

            isSmallScreen ?
              <>
                <Typography className={CaptureStyles.footerText}>
                  Please allow LOCATION and CAMERA permissions when requested. You
                  need to do this only ONCE as per SEBI regulations, to open a Demat
                  account.
                </Typography>
                  <Grid2
                    container
                    mt={3}
                    direction={{ xs: "column-reverse", md: "row" }}
                    spacing={1}
                  >
                    <Grid2 mb={2}>
                      <Button
                        className={CaptureStyles.skip_button}
                        variant="outlined"
                        onClick={handleSkipCS}
                      >
                        Skip Now
                      </Button>
                    </Grid2>

                    <Grid2 >
                      <Button
                        onClick={() => setOpenCamera(true)}
                        className={CaptureStyles.con_button}
                      >
                        Open Camera
                      </Button>
                    </Grid2>
                  </Grid2>

              </> :
              <>
                <Grid2 className={CaptureStyles.but_card}>
                  <Grid2>
                            <Button
                                    className={CaptureStyles.skip_button}
                                    variant="outlined"
                                   onClick={handleSkipCS}
                                >
                                    Skip Now
                                </Button>
                            </Grid2>
                  <Grid2>
                    <Button onClick={() => setOpenCamera(true)} className={CaptureStyles.con_button}>Open Camera</Button>
                  </Grid2>
                </Grid2>

              </>
          }


          <Box className={CaptureStyles.card}>
            <img
              src={icon} // Replace with your image URL
              alt="Checkmark"
              className={CaptureStyles.icon}
            />
            <Typography className={CaptureStyles.txt}>
              Your account details are safe & secure with us.
            </Typography>
          </Box>
        </Box>}

      </>}
    </Box>
    </main>
  );
}
